export default __webpack_public_path__ + "assets/img/ic-voiceactive.1a2086ebd89f0272a7f83bcd20bcadf4.svg";